/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import PropTypes from 'prop-types';

import { PromoCodeListItem } from './promo_code_list_item.jsx';

export class PromoCode extends React.Component {
        static propTypes = {
          promoCodes: PropTypes.array,
          availableTicketClasses: PropTypes.array,
          header: PropTypes.bool,
          onChange: PropTypes.func,
          onDelete: PropTypes.func,
          onAddTicketClass: PropTypes.func,
          onRemoveTicketClass: PropTypes.func,
          openedEditors: PropTypes.array,
          onToggleEditor: PropTypes.func,
          onAddPromoCode: PropTypes.func
        };

        static defaultProps = {
          promoCodes: [],
          openedEditors: [],
          header: true
        };

        render() {

          const header = this.props.header ?
            <thead>
              <tr>
                <th>Code</th>
                <th># Uses</th>
                <th></th>
              </tr>
            </thead> : undefined;

          const contents = this.props.promoCodes.length === 0 ?
            <tbody>
              <tr>
                <td colSpan="3">
                  <a href="#" onClick={this.props.onAddPromoCode}>Create your first promo code</a>
                </td>
              </tr>
            </tbody>
          :
            Array.from(this.props.promoCodes).map((promo_code) =>
              <PromoCodeListItem key={promo_code.id}
                                  settings={this.props.settings}
                                  promoCode={promo_code}
                                  showEditor={this.props.openedEditors.indexOf(promo_code.id) > -1}
                                  availableTicketClasses={this.props.availableTicketClasses}
                                  onChange={this.props.onChange}
                                  onDelete={this.props.onDelete}
                                  onToggleEditor={this.props.onToggleEditor}
                                  onAddTicketClass={this.props.onAddTicketClass}
                                  onRemoveTicketClass={this.props.onRemoveTicketClass} />);

          return <table className="form-item-list">
            {header}

            {contents}
          </table>;
        }
}

